import _Vue from "vue";
import { DataHelper } from "../../utils/data-helper";
import moment from "moment";
import { LanguageHelper } from "../../utils/language-helper";
export class PluginOptions { }

const TranslatorPlugin = {
    install(Vue: typeof _Vue, options?: PluginOptions) {
        console.log("TranslatorPlugin plugin is installing");

        Vue.prototype.$df = function (value: any) {
            if (value === undefined || value === null) return null;
            return DataHelper.formatDate(moment(value));
        };

        Vue.prototype.$tf = function (value: any) {
            if (value === undefined || value === null) return null;
            return DataHelper.formatTime(moment(value));
        };

        Vue.prototype.$td = function (item: any, props?: string, l?: string) {
            if (props === undefined) props = "Name";
            let langCode = l || this.$i18n.locale;
            let langShortCode: string = langCode;
            let locale: string = LanguageHelper.getLanguageShortCode(langShortCode);
            return (function set(obj: any, str: string, shortLang: string) {
                let str1 = str.split(".");
                while (str1.length > 1 && obj !== undefined) {
                    obj = obj[str1.shift()];
                }
                if (obj === undefined) return null;
                let s = obj[str1.shift() + shortLang];
                if (s === "" || s === undefined) {
                    s = " ";
                }
                return s;
            })(item, props, locale);
        };
    }
};

export default TranslatorPlugin;
